import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import {
  Avatar,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  Typography,
  LinearProgress,
  Modal,
  Box,
} from '@material-ui/core';

import axios from 'axios';
import auth from '../../../../utils/auth';
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0)
  },
  basis: {
    display: 'flex', 
    marginBottom: theme.spacing(2),
  },
  detail: {
    marginTop: theme.spacing(2),
  },
  avatar: {
    marginLeft: 'auto',
    height: 60,
    width: 60,
    flexShrink: 0,
    flexGrow: 0
  },
  progress: {
    marginTop: theme.spacing(2), display: 'none'
  },
  uploadButton: {
    marginRight: theme.spacing(2)
  },
  spaceAround :{
    justifyContent:'space-around'
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalPaper: {
    width: 280,
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '12px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 2),
    textAlign: 'center',
    color: '#444444',
    whiteSpace: 'pre-wrap',
  },
  modalBody1: {
    fontSize: '11px',
    textAlign: 'left',
    margin: '5px 0',
  },
  modalBody2: {
    fontSize: '11px',
    fontWeight: 800,
    lineHeight: '22px',
    textAlign: 'left',
    wordBreak: 'keep-all',
    margin: '5px 0',
  },
  modalButton: {
    width: '100%',
    boxShadow: 'none',
    fontSize: '20px',
    fontWeight: 800,
    borderRadius: '12px',
  },
}));

const Profile = props => {
  //다국어적용 t('component.key')
  const { t }  = useTranslation(['page']);
  
  const classes = useStyles();
  const { userInfo, extraInfo, auth } = props;
	const [withdrawModalOpen, setWithdrawModalOpen]= useState(false);

  const handleClickSignOut = event => {
    event.preventDefault();

    auth.clearToken();
    window.location.reload();
//    history.push('/');
  }

  const handleClickWithdraw = e => {
    // if(window.confirm(t('Options.withdrawConfirm'))) {
      // 비밀번호 입력 팝업 띄우기
      setWithdrawModalOpen(true)
    // }
  }

  const handleWithdraw = e => {
    if(values.confirmPassword === '' || values.confirmPassword === null || values.confirmPassword === undefined) {
      alert(t('SignUp.errorPasswordNull'));
    } else {
      if(auth.getToken() !== null) {
        const auth_str = 'Bearer '.concat((auth.getToken().token)); 

        axios.post(
          `${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/leave-riduck.php`, 
          {
            password : values.confirmPassword
          }, 		
          { 
            headers: { Authorization: auth_str }, 
          }
        ).then(response => {
          // console.log(response);
          if(response.data.success) {
            alert(t('Options.withdrawSuccess'));
            // e.preventDefault();
            auth.clearToken();
            window.location.reload();
          } else {
            if(response.data.message === 'password_incorrect') {
              alert(t('Options.passwordIncorrect'));
            } else {
              alert(t('Options.withdrawFail'));
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    }
  }

  const [values, setValues] = useState({
    username: userInfo.display_name,
    email: userInfo.user_email,
    confirmPassword: ''
  });

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };


/*
age: "34"
athlete_json: "{"id": 3350953, "sex": "M", "city": "Seoul", "state": "", "friend": null, "summit": true, "country": "South Korea", "premium": true, "profile": "https://dgalywyr863hv.cloudfront.net/pictures/athletes/3350953/4808634/9/large.jpg", "follower": null, "lastname": "ubd81uc545uc5d0uba67ub3fcuc9c0ucd9cubab0", "username": null, "firstname": "ud83dudc17", "created_at": "2013-11-07T21:30:54Z", "updated_at": "2020-06-09T03:11:56Z", "badge_type_id": 1, "profile_medium": "https://dgalywyr863hv.cloudfront.net/pictures/athletes/3350953/4808634/9/medium.jpg", "resource_state": 2}"
bikeKit_json: "{"cda": 0.323756, "crr": 0.0045, "gender": "M", "cadence": "100", "bike_type": "road_allround", "drivetrain": "ultegra", "rider_pose": "1", "rim_height": "2", "tire_width": "2", "bike_weight": 6, "rider_height": 168, "rider_weight": 58, "tire_product": "Clincher high (butyl)", "surface_select": "2"}"
bikes: "hybrid"
extrainfo_id: "56"
gender: "M"
height: "170"
nation: "Korea"
pdc_json: "null"
pretest: "2"
profile_image: "https://dgalywyr863hv.cloudfront.net/pictures/athletes/3350953/4808634/9/large.jpg"
purposes: "fitness"
race_category: ""
refresh_token: "01fa72d875f6a6200bc22e144106cf1592c598e8"
rider_type: ""
riding_type: "indoor"
riding_year: "2"
strava_id: "3350953"
strava_token: "a141fdc530b69980d712c0ae0f35c3320f3992b5"
user_id: "46"
extrainfo_id: "56"

gender: "M"
height: "170"
nation: "Korea"
weight: "64"
*/


  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item lg={5} md={6} xl={4} xs={12}>
          <Card className={clsx(classes.root, classes)}>
            <CardContent>
              <div className={classes.basis}>
                <div>
                  <Typography>
                    {userInfo.display_name}
                  </Typography>
                  <Typography
                    className={classes.locationText}
                    color="textSecondary"
                    variant="body1"
                  >
                    {userInfo.email}
                  </Typography>
                  <Typography
                    className={classes.dateText}
                    color="textSecondary"
                    variant="body1"
                  >
                    {userInfo.user_login}
                  </Typography>
                  {extraInfo.gender}, {extraInfo.height} cm, {extraInfo.weight} kg, {extraInfo.nation}
                </div>
                <Avatar
                  className={classes.avatar}
                  src={extraInfo.profile_image}
                />
              </div>
              <div className={classes.progress}>
                <Typography variant="body1">Profile Completeness: 70%</Typography>
                <LinearProgress value={70} variant="determinate" />
              </div>
              <Divider />
              <div className={classes.detail}>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={7} md={6} xl={8} xs={12}>
          <Card className={clsx(classes.root, classes)}>
            <form autoComplete="off" noValidate>
              <CardHeader subheader="" title="Profile" />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label={t('SignUp.nickname')}
                      name={t('SignUp.nickname')}
                      onChange={handleChange}
                      required
                      value={values.username}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label={t('SignUp.email')}
                      name={t('SignUp.email')}
                      onChange={handleChange}
                      required
                      value={values.email}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <CardActions className={classes.spaceAround}>
                <Button color="primary" variant="contained" disabled>
                  {t('Options.modify')}
                </Button>
                <Button color="secondary" variant="contained" style={{color: "rgba(0, 0, 0, 0.26)",backgroundColor: "rgba(0, 0, 0, 0.12)",}} onClick={handleClickWithdraw}>
                  {t('Options.withdraw')}
                </Button>
                {(auth.getToken() !== null) ? 
                (<React.Fragment>
                  <Button color="secondary" variant="contained" onClick={handleClickSignOut}>
                    {t('Options.signOut')}
                  </Button>
                </React.Fragment>)
                : (<React.Fragment></React.Fragment>)}
              </CardActions>
            </form>
          </Card>
        </Grid>
      </Grid>
      <div>
        <Modal
            open={withdrawModalOpen}
            onClose={() => setWithdrawModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={classes.modal}
          >
            <div className={classes.modalPaper}>
              <Box style={{margin: '10px 0 15px'}}>
                <Typography variant="h4" component="h2" style={{fontWeight: 600, marginBottom: 15}}>{t('Common.information')}</Typography>
                <Typography className={classes.modalBody1}>{t('Options.withdrawDesc1')}</Typography>
                <Typography className={classes.modalBody1} style={{fontWeight:600, margin:'10px auto'}}>{t('Options.withdrawDesc2')}</Typography>
                <Box>
                  <TextField
                    className={classes.textField}
                    fullWidth
                    label={t('SignUp.confirmPassword')}
                    name="confirmPassword"
                    onChange={handleChange}
                    type="password"
                    variant="outlined"
                  />
                </Box>
              </Box>
              <Box>
                <Button variant="contained" color="secondary" onClick={handleWithdraw} className={classes.modalButton}>{t('Options.withdraw')}</Button>
                {/* <Button variant="contained" color="primary" onClick={() => setWithdrawModalOpen(false)} className={classes.modalButton}>{t('Options.cancel')}</Button> */}
              </Box>
            </div>
          </Modal>
      </div>
    </div>
  );
};

export default Profile;
